<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'expenseDetail',
    components: {
      baseEdit,
    },
  };
</script>
